import cx from "classnames";
import has from "lodash/has";
import words from "lodash/words";
import { PureComponent } from "react";
import { connect } from "react-redux";
import { getEventDesktop } from "../../../../../../../../api/eventsApi";
import Collapsible from "../../../../../../../../components/Collapsible/Collapsible";
import PositionMatrix from "../../../../../../../../components/PositionMatrix/PositionMatrix";
import type { PositionMatrixType } from "../../../../../../../../types/positionMatrixType";
import { REGEX_VS } from "../../../../../../../../utils/const";
import "./PositionMatrixItem.scss";
type Props = {
  positionMatrix: PositionMatrixType;
  setPositionMatrixModalItem: (...args: Array<any>) => any;
  setPositionMatrixModalEvent: (...args: Array<any>) => any;
  openPositionMatrixModal: (...args: Array<any>) => any;
};
type State = {
  isActive: boolean;
  event: any;
};

class PositionMatrixItem extends PureComponent<Props, State> {
  intervalId: any;

  constructor(props: any) {
    super(props);
    this.state = {
      isActive: true,
      event: {},
    };
    this.startIntervalFetchEvent();
  }

  openModal = () => {
    const {
      positionMatrix,
      setPositionMatrixModalEvent,
      openPositionMatrixModal,
      setPositionMatrixModalItem,
    } = this.props;

    getEventDesktop(positionMatrix.eventId).then(resp => {
      setPositionMatrixModalEvent(resp);
      openPositionMatrixModal();
      // BET-12235 adding missing request to get missing position matrix data
      // for selected open position
      setPositionMatrixModalItem(resp.id);
    });
  };

  getEventData = (eventId: number) => {
    getEventDesktop(eventId).then(resp => {
      this.setState({
        event: resp,
      });
    });
  };
  renderTeamName = (teamName: string) => {
    return (
      <div className="position-matrix-item__header__team-name">
        <span>{teamName}</span>
      </div>
    );
  };
  startIntervalFetchEvent = () => {
    if (
      !has(this.props.positionMatrix, "participant1") ||
      this.props.positionMatrix.live
    ) {
      this.getEventData(this.props.positionMatrix.eventId);
      this.intervalId = setInterval(() => {
        this.getEventData(this.props.positionMatrix.eventId);
      }, 15000);
    }
  };
  endIntervalFetchEvent = () => {
    clearInterval(this.intervalId);
  };
  render = () => {
    const { positionMatrix } = this.props;
    // Get the " vs " or " at " from the event name
    let teamVS = words(positionMatrix.eventName, REGEX_VS);
    // Get the two team names (without the "vs" or "at")
    let teamNames = positionMatrix.eventName.split(REGEX_VS);
    return (
      <div className="position-matrix-item">
        <Collapsible
          status={"open"}
          header={
            <div className="position-matrix-item__header">
              <div
                className={cx("position-matrix-item__header__arrow", {
                  "position-matrix-item__header__arrow--up":
                    this.state.isActive,
                  "position-matrix-item__header__arrow--down":
                    !this.state.isActive,
                })}
                onClick={() => {
                  this.setState({
                    isActive: !this.state.isActive,
                  });
                }}
              />
              <div className="position-matrix-item__header__teams">
                {this.renderTeamName(teamNames[0])}
                <div className="position-matrix-item__header__team-vs">
                  {teamVS[0]}
                </div>
                {this.renderTeamName(teamNames[1])}
              </div>
              <div className="position-matrix-item__header__rhs" />
            </div>
          }
          content={
            <PositionMatrix
              positionMatrices={[positionMatrix]}
              event={this.state.event}
              betDrawerScreen={true}
              onClickExpand={this.openModal}
            />
          }
          isActive={this.state.isActive}
        />
      </div>
    );
  };
}

const mapDispatchToProps = dispatch => ({
  setPositionMatrixModalItem: (eventId: number) => {
    dispatch.positionMatrixListModel.setPositionMatrixModalItem({
      eventId: eventId,
    });
  },
  setPositionMatrixModalEvent: (event: any) => {
    dispatch.positionMatrixListModel.setPositionMatrixModalEvent(event);
  },
  openPositionMatrixModal: () => {
    dispatch.positionMatrixListModel.openPositionMatrixModal();
  },
});

export default connect(null, mapDispatchToProps)(PositionMatrixItem) as any;
